export const hsnDatabase = {

  // AGRICULTURE / NURSERY
  "0601": { gst: "5", name: "Bulbs & Roots" },
  "0602": { gst: "5", name: "Live Plants" },
  "0603": { gst: "5", name: "Cut Flowers" },
  "0604": { gst: "5", name: "Foliage & Branches" },

  "1201": { gst: "5", name: "Soya Beans" },
  "1202": { gst: "5", name: "Ground Nuts" },
  "1203": { gst: "5", name: "Copra" },
  "1204": { gst: "5", name: "Linseed" },
  "1205": { gst: "5", name: "Rapeseeds" },
  "1206": { gst: "5", name: "Sunflower Seeds" },
  "1207": { gst: "5", name: "Other Oil Seeds" },

  "3101": { gst: "5", name: "Organic Fertilizers" },
  "3102": { gst: "5", name: "Nitrogen Fertilizers" },
  "3103": { gst: "5", name: "Phosphatic Fertilizers" },
  "3104": { gst: "5", name: "Potassic Fertilizers" },
  "3105": { gst: "5", name: "Mixed Fertilizers" },

  "3808": { gst: "18", name: "Pesticides & Insecticides" },

  // FOOD ITEMS
  "0401": { gst: "0", name: "Milk" },
  "0402": { gst: "5", name: "Milk Powder" },
  "0403": { gst: "5", name: "Curd & Yogurt" },

  "1001": { gst: "0", name: "Wheat" },
  "1002": { gst: "0", name: "Rye" },
  "1003": { gst: "0", name: "Barley" },
  "1004": { gst: "0", name: "Oats" },
  "1005": { gst: "0", name: "Maize" },
  "1006": { gst: "0", name: "Rice" },

  "1101": { gst: "5", name: "Wheat Flour" },
  "1102": { gst: "5", name: "Cereal Flour" },

  "1701": { gst: "5", name: "Sugar" },
  "1702": { gst: "12", name: "Other Sugars" },

  "1905": { gst: "18", name: "Biscuits & Bakery" },

  // CLOTHING
  "6101": { gst: "5", name: "Men Overcoats" },
  "6102": { gst: "5", name: "Women Overcoats" },
  "6103": { gst: "5", name: "Men Suits" },
  "6104": { gst: "5", name: "Women Suits" },
  "6105": { gst: "5", name: "Men Shirts" },
  "6106": { gst: "5", name: "Women Blouses" },
  "6107": { gst: "5", name: "Men Innerwear" },
  "6108": { gst: "5", name: "Women Innerwear" },
  "6109": { gst: "5", name: "T-Shirts" },
  "6110": { gst: "5", name: "Sweaters" },

  "6201": { gst: "12", name: "Men Jackets" },
  "6202": { gst: "12", name: "Women Jackets" },
  "6203": { gst: "12", name: "Men Clothing" },
  "6204": { gst: "12", name: "Women Clothing" },

  // ELECTRONICS
  "8471": { gst: "18", name: "Computers & Laptops" },
  "8473": { gst: "18", name: "Computer Parts" },
  "8517": { gst: "18", name: "Mobile Phones" },
  "8518": { gst: "18", name: "Speakers & Audio" },
  "8528": { gst: "28", name: "Televisions" },

  // HARDWARE
  "7308": { gst: "18", name: "Steel Structures" },
  "7318": { gst: "18", name: "Bolts & Nuts" },
  "7323": { gst: "18", name: "Steel Household Items" },

  // PLASTIC
  "3917": { gst: "18", name: "Plastic Pipes" },
  "3918": { gst: "18", name: "Plastic Floor Coverings" },
  "3923": { gst: "18", name: "Plastic Packaging" },
  "3924": { gst: "18", name: "Plastic Household Items" },
  "3926": { gst: "18", name: "Plastic Products" },

  // STATIONERY
  "4802": { gst: "12", name: "Paper Sheets" },
  "4820": { gst: "12", name: "Registers & Notebooks" },
  "9608": { gst: "18", name: "Pens & Markers" },

  // AUTOMOBILE
  "8407": { gst: "28", name: "Petrol Engines" },
  "8408": { gst: "28", name: "Diesel Engines" },
  "8703": { gst: "28", name: "Motor Cars" },
  "8711": { gst: "28", name: "Motorcycles" },

  // MEDICAL
  "3002": { gst: "12", name: "Medicines" },
  "3004": { gst: "12", name: "Pharmaceutical Products" },
  "9018": { gst: "12", name: "Medical Instruments" },

  // FURNITURE
  "9401": { gst: "18", name: "Seats & Chairs" },
  "9403": { gst: "18", name: "Furniture" },
  "9405": { gst: "18", name: "Lights & Lamps" },

  // SERVICES
  "9983": { gst: "18", name: "IT Services" },
  "9985": { gst: "18", name: "Support Services" },
  "9987": { gst: "18", name: "Maintenance Services" },

  // EXTRA COMMON CODES
  "2201": { gst: "12", name: "Water Bottles" },
  "2202": { gst: "28", name: "Soft Drinks" },
  "2402": { gst: "28", name: "Cigarettes" },
  "2501": { gst: "5", name: "Salt" },
  "2710": { gst: "18", name: "Petroleum Oils" },
  "3208": { gst: "18", name: "Paints & Varnishes" },
  "3304": { gst: "18", name: "Beauty Products" },
  "3401": { gst: "18", name: "Soap" },
  "3402": { gst: "18", name: "Cleaning Products" },
  "3506": { gst: "18", name: "Glue & Adhesives" },
  "4011": { gst: "28", name: "Tyres" },
  "4202": { gst: "18", name: "Bags & Suitcases" },
  "4410": { gst: "18", name: "Wood Panels" },
  "4411": { gst: "18", name: "Fiber Boards" },
  "4421": { gst: "18", name: "Wood Articles" },
  "4819": { gst: "12", name: "Cartons & Boxes" },
  "4901": { gst: "0", name: "Books" },
  "4911": { gst: "12", name: "Printed Materials" },
  "6403": { gst: "18", name: "Leather Footwear" },
  "6404": { gst: "18", name: "Rubber Footwear" },
  "6802": { gst: "18", name: "Granite & Marble" },
  "6810": { gst: "18", name: "Cement Articles" },
  "6907": { gst: "18", name: "Tiles" },
  "7007": { gst: "18", name: "Safety Glass" },
  "7208": { gst: "18", name: "Steel Sheets" },
  "7214": { gst: "18", name: "Steel Bars" },
  "7306": { gst: "18", name: "Iron Pipes" },
  "7418": { gst: "18", name: "Copper Household Items" },
  "7604": { gst: "18", name: "Aluminium Bars" },
  "8201": { gst: "18", name: "Hand Tools" },
  "8205": { gst: "18", name: "Tool Sets" },
  "8414": { gst: "18", name: "Air Pumps" },
  "8415": { gst: "28", name: "Air Conditioners" },
  "8421": { gst: "18", name: "Water Filters" },
  "8432": { gst: "12", name: "Agriculture Machinery" },
  "8443": { gst: "18", name: "Printers" },
  "8450": { gst: "28", name: "Washing Machines" },
  "8501": { gst: "18", name: "Electric Motors" },
  "8504": { gst: "18", name: "Transformers" },
  "8507": { gst: "28", name: "Batteries" },
  "8516": { gst: "18", name: "Electric Heaters" },
  "8525": { gst: "18", name: "CCTV Cameras" },
  "8536": { gst: "18", name: "Electrical Switches" },
  "8544": { gst: "18", name: "Electrical Wires" },
  "8708": { gst: "28", name: "Vehicle Parts" },
  "8714": { gst: "28", name: "Bike Parts" },
  "9004": { gst: "18", name: "Spectacles" },
  "9102": { gst: "18", name: "Wrist Watches" },
  "9404": { gst: "18", name: "Mattresses" },
  "9503": { gst: "12", name: "Toys" },
  "9603": { gst: "18", name: "Brooms & Brushes" }

};

export default hsnDatabase;